import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';

export class Breadcrumbs extends LightLitElement {
    static get properties() {
        return {
            name: { type: String },
            location: { type: String },
            twoWayNavigation: {
                type: Boolean,
                attribute: 'two-way-navigation',
            },
        };
    }

    constructor() {
        super();
        this.name = '';
        this.location = null;
        this.twoWayNavigation = false;
    }

    render() {
        return html`
            <div class="e2-breadcrumbs__container">
                <v-slot name="list"></v-slot>
            </div>
        `;
    }
}

export default () => customElements.define('e2-breadcrumbs', Breadcrumbs);
